/**
 * Berat input (gram) → kuantiti mili-unit.
 *
 * Domain menyimpan kuantiti sebagai 1/1000 unit dan harga per SATU unit. Jadi:
 *   - unit kg: 100 g = 100 mili-kg = 0.1 kg
 *   - unit g : 100 g = 100,000 mili-g = 100 g
 * Sebelum ini POS sentiasa menyimpan gram sebagai mili-unit, jadi barang berunit "g" menjadi
 * 0.100 g — 1000 kali terlalu kecil, dan resit menunjukkan angka yang salah.
 */

export type WeightUnit = 'kg' | 'g' | 'l' | 'ml' | 'm';

/** Unit kecil yang perlu didarab 1000 untuk menjadi mili-unit. */
const SMALL_UNITS: readonly WeightUnit[] = ['g', 'ml'];

export function qtyMilliFromWeight(input: number, unit: string): number {
  const factor = SMALL_UNITS.includes(unit as WeightUnit) ? 1000 : 1;
  return Math.round(input * factor);
}

/** Langkah satu tekan butang − / + untuk barang berat, dalam mili-unit. */
export function weightStep(unit: string): number {
  // 100 g untuk unit kecil; 0.1 kg untuk unit besar.
  return SMALL_UNITS.includes(unit as WeightUnit) ? 100_000 : 100;
}
